import clamp from './clamp';

export default function invlerp(start: number, end: number, value: number): number {
  return clamp((value - start) / (end - start));
}
